var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleUser = function SvgCircleUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.624 25.27A11.99 11.99 0 0 0 28 16c0-6.625-5.375-12-12-12S4 9.375 4 16a11.99 11.99 0 0 0 4.375 9.27L10.4 19.2h11.2zm-.675.515L21.024 20H10.98l-1.93 5.785A11.95 11.95 0 0 0 16 28c2.59 0 4.99-.82 6.95-2.215m.265.79A12.74 12.74 0 0 1 16 28.8a12.74 12.74 0 0 1-7.84-2.68c-.015-.015-.035-.025-.05-.04A12.78 12.78 0 0 1 3.2 16C3.2 8.93 8.93 3.2 16 3.2S28.8 8.93 28.8 16c0 4.09-1.92 7.735-4.905 10.08q-.331.255-.67.495l-.005.005zM12 13.6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4 3.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4"
  })));
};
export default SvgCircleUser;